import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { EuthanasiaAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-euthanasia-slot',
    templateUrl: './euthanasia-slot.component.html',
    styleUrl: './euthanasia-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EuthanasiaSlotComponent implements SheetSlotComponentBase {

	@Input() action!: EuthanasiaAction;
	value = null;

	constructor() {
	}
}